import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
export default class LinkGuardDestination extends Component {
  view() {
    const {
      target
    } = this.attrs;
    return m("dl", {
      className: "LinkGuardPage-destination"
    }, m("dt", null, app.translator.trans('ffans-link-guard.forum.destination_label')), m("dd", {
      className: "LinkGuardPage-host",
      dir: "ltr"
    }, target.host), m("dd", {
      className: "LinkGuardPage-url",
      dir: "ltr"
    }, target.href));
  }
}
flarum.reg.add('ffans-link-guard', 'forum/components/LinkGuardDestination', LinkGuardDestination);